















import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import Dialog from '../../components/Dialog.vue';
import QueryTabularResults from '../../components/publish/datasets/QueryTabularResults.vue';

@Component({
  components: {
    Dialog,
    QueryTabularResults,
  },
})
export default class DataSetDataDialog extends Vue {

  @Prop() private datasetUuid!: string;
  @Prop({default: false}) private showDialog!: boolean;
  private openDialog: boolean = false;
  private isPropBased: boolean = false;
  private loading: boolean = false;

  private async mounted() {
    if (this.$route.params.datasetUuid) {
      this.openDialog = true;
    } else {
      this.isPropBased = true;
      this.openDialog = this.showDialog;
    }
  }

  private closeDialog() {
    if (this.loading) {
      return;
    }
    if (!this.isPropBased) {
      this.openDialog = false;
      this.$router.go(-1);
    } else {
      this.$emit('close');
    }
  }

  private get currDatasetUuid(): string | null {
    if (!this.openDialog) {
      return null;
    }
    return this.$route.params.datasetUuid ? this.$route.params.datasetUuid : this.datasetUuid;
  }

  @Watch('showDialog')
  private onShowDialogChange() {
    this.openDialog = this.showDialog;
  }

}
